<template>
  <v-main style="margin: 10px">
    <v-card class="d-flex flex-column align-content-center" min-height="155">
      <v-row no-gutters style="padding: 20px 10px 15px">
        <v-col cols="12" sm="8">
          <div class="d-flex px-2">
            <h2>Waiver Report</h2>
          </div>
        </v-col>
      </v-row>

      <!-- Score Spot Report -->
      <v-card class="d-flex flex-column align-content-center mt-2" min-height="155">
        <v-card-text>
          <v-form ref="form2" no-gutters class="d-flex flex-wrap">
            <v-row>
              <v-col cols="3" class="date-block ma-2 px-5" style="min-width: 200px">
                <v-menu ref="dateScoreSpotStartPicker" v-model="dateScoreSpotStartMenu" :close-on-content-click="false"
                  :return-value.sync="dateScoreSpotStart" transition="scale-transition" offset-y max-width="320px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field id="dateScoreSpotStart" :v-model="dateScoreSpotStart"
                      :value="$root.parseDate(dateScoreSpotStart)" readonly v-on="on" v-bind="attrs"
                      :rules="[(v) => !!v || 'Enter start date']" @click:prepend="dateScoreSpotStartMenu = true">
                      <template v-slot:append>
                        <img v-on="on" v-bind="attrs" width="24" height="24" src="/icon/icon-calendar.svg" />
                      </template>
                      <template v-slot:label>
                        <span style="font-size: 17px; color: black !important">Start date</span>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dateScoreSpotStart" no-title scrollable style="width: 100%">
                    <v-row no-gutters justify="space-around" class="pa-4" style="min-width: 304px">
                      <v-btn width="120" class="mx-0" outlined color="primary"
                        @click="$refs.dateScoreSpotStartPicker.save(dateScoreSpotStart)">Confirm</v-btn>
                      <v-btn width="120" class="mx-0" outlined @click="dateScoreSpotStartMenu = false">Cancel</v-btn>
                    </v-row>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" class="date-block ma-2 px-5" style="min-width: 200px">
                <v-menu ref="dateScoreSpotEndPicker" v-model="dateScoreSpotEndMenu" :close-on-content-click="false"
                  :return-value.sync="dateScoreSpotEnd" transition="scale-transition" offset-y max-width="320px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field id="dateScoreSpotStart" :v-model="dateScoreSpotEnd"
                      :value="$root.parseDate(dateScoreSpotEnd)" readonly v-on="on" v-bind="attrs"
                      :rules="[(v) => !!v || 'Enter end date']" @click:prepend="dateScoreSpotEndMenu = true">
                      <template v-slot:append>
                        <img v-on="on" v-bind="attrs" width="24" height="24" src="/icon/icon-calendar.svg" />
                      </template>
                      <template v-slot:label>
                        <span style="font-size: 17px; color: black !important">End date</span>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dateScoreSpotEnd" no-title scrollable style="width: 100%">
                    <v-row no-gutters justify="space-around" class="pa-4" style="min-width: 304px">
                      <v-btn width="120" class="mx-0" outlined color="primary"
                        @click="$refs.dateScoreSpotEndPicker.save(dateScoreSpotEnd)">Confirm</v-btn>
                      <v-btn width="120" class="mx-0" outlined @click="dateScoreSpotEndMenu = false">Cancel</v-btn>
                    </v-row>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex flex-wrap">
          <v-btn medium class="mt-2 ml-0" color="primary" @click="downloadScoreSpotReport"><v-icon
              left>mdi-export</v-icon> Export Waiver Report</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-main>
</template>

<style scoped>
.date-block {
  max-width: 230px !important;
}
</style>

<script>
import axios from "axios";

export default {
  data() {
    return {
      dateScoreSpotStartMenu: false,
      dateScoreSpotStart: null,
      dateScoreSpotEndMenu: false,
      dateScoreSpotEnd: null,
      linksFilter: "",
      visitLinks: []
    };
  },
  mounted() {
    // this.listAllValue();
  },
  methods: {
    downloadScoreSpotReport() {
      if (this.$refs.form2.validate()) {
        window.open(axios.defaults.baseURL + "/system/waiver/report/export?dateStart=" + this.dateScoreSpotStart + "&dateEnd=" + this.dateScoreSpotEnd);
      }
    },
  }
};
</script>
